import { ComponentType } from "react";
import AggregatedDrivers from "./AggregatedDriver";
import Attendants from "./Attendant";
import Bills from "./Bill/index";
import Chains from "./Chain";
import ChainEmployees from "./ChainEmployee";
import Chats from "./Chat";
import Cities from "./City";
import Companies from "./Company";
import CompanyConfig from "./CompanyConfig";
import CompanyEmployees from "./CompanyEmployee";
import Contracts from "./Contract";
import CostCenters from "./CostCenter";
import Customers from "./Customer";
import Drivers from './Driver';
import ExternalPartners from './ExternalPartner';
import Fillins from "./Fillin";
import FillinAttempt from "./FillinAttempt";
import FillinContractPriceAlerts from "./FillinContractPriceAlert";
import Fuels from "./Fuel";
import Invoices from './Invoice';
import LinkedChains from "./LinkedChains";
import LinkedCompanies from "./LinkedCompanies";
import MailingList from './MailingList';
import Managers from "./Manager";
import PushNotifications from "./Notification";
import Operations from "./Operation";
import OptCodes from "./OtpCodes";
import ParentFuels from "./ParentFuel";
import Partners from "./Partner";
import PermissionGroups from "./PermissionGroups/index";
import Permissions from "./Permissions/index";
import Profiles from "./Profiles/index";
import Ratings from "./Rating";
import RatingPollItems from "./RatingPollItems";
import Routes from "./Route";
import Rules from "./Rule";
import Services from "./Service";
import Stations from "./Station";
import StationBillings from './StationBilling';
import StationEmployees from "./StationEmployee";
import SubCompanies from "./SubCompany";
import SubCompanyBillings from './SubCompanyBilling';
import SystemConfig from "./SystemConfig";
import SystemUsers from "./systemUsers";
import Valets from "./Valet";
import Vehicles from "./Vehicle";
import VehicleBases from "./VehicleBase";
import VehicleGroups from "./VehicleGroup";
import Vouchers from "./Voucher";
import TaxAuditLogs from "./TaxAuditLogs";

export interface Resource {
    name: string;
    permissions: string[];
    list?: ComponentType | ComponentWithPermissions;
    create?: ComponentType | ComponentWithPermissions;
    edit?: ComponentType | ComponentWithPermissions;
    show?: ComponentType | ComponentWithPermissions;
}

const containers: Array<Resource> = [
    Drivers,
    ExternalPartners,
    MailingList,
    PermissionGroups,
    Permissions,
    Profiles,
    ChainEmployees,
    CompanyEmployees,
    CostCenters,
    Chains,
    Services,
    AggregatedDrivers,
    Attendants,
    Cities,
    Customers,
    Fuels,
    Invoices,
    Managers,
    CompanyConfig,
    SystemConfig,
    PushNotifications,
    OptCodes,
    ParentFuels,
    Partners,
    Ratings,
    RatingPollItems,
    Routes,
    Rules,
    Stations,
    StationEmployees,
    SubCompanies,
    Companies,
    SubCompanyBillings,
    StationBillings,
    Chats,
    Valets,
    Vehicles,
    VehicleBases,
    VehicleGroups,
    Vouchers,
    Contracts,
    Bills,
    Fillins,
    LinkedCompanies,
    LinkedChains,
    FillinAttempt,
    SubCompanies,
    Companies,
    Operations,
    FillinContractPriceAlerts,
    SystemUsers,
    TaxAuditLogs,
];

export default containers;